import { ReactMarkdown } from 'react-markdown/lib/react-markdown'

import * as S from './styles'

export type AboutContainerProps = {
  /**
   * The `about` text
   *
   * @example
   * ```tsx
   * <AboutContainer about="This is the about text" />
   * ```
   */
  about: string
}

export const AboutContainer: React.FC<AboutContainerProps> = ({ about }) => (
  <S.AboutContainer>
    <ReactMarkdown className="about">{about}</ReactMarkdown>
  </S.AboutContainer>
)
